import React from 'react';
import { NavLink } from 'react-router-dom';
import { withLocation } from './../Common/withLocation'; // Importa el HOC que creaste
import {devitems} from './../Common/Helpers';
import UniqueSelect from './../Common/UniqueSelect';
import { initializeIsotopeGrid, applyIsotopeFilter } from './customFiltros';

const images = [
    require('./../../images/about-slider/1.jpg'),
    require('./../../images/about-slider/2.jpg'),
    require('./../../images/about-slider/3.jpg'),
    require('./../../images/about-slider/4.jpg'),
    require('./../../images/about-slider/5.jpg')
]

var bgimg1 = require('./../../images/background/bg-4.png');
var bgimg2 = require('./../../images/background/cross-line2.png');

const GRID_SELECTOR = '.masonry-outer';

class Filtros extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // Datos del formulario
            nombre: '',
            centropenal: '',
            departamento: '',
            // Datos del grid
            items: props.data || [], 
        };
    }

    // =================================================================
    // CICLO DE VIDA
    // =================================================================
    
    componentDidMount() {
        // Inicializa Isotope después de que React monta el DOM por primera vez
        initializeIsotopeGrid(GRID_SELECTOR);
    }
    
    componentWillUnmount() {
        // Limpieza de la instancia de Isotope al desmontar el componente
        //destroyIsotopeGrid();
    }
    
    // =================================================================
    // MANEJO DE FORMULARIO DE REACT
    // =================================================================
    
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSearch = (e) => {
        e.preventDefault();

        //console.info("submitTTTTTT");
        
        // Llamar a la función externa con los datos del estado de React
        applyIsotopeFilter(this.state);
    }

    handleReset = () => {
        this.setState({ nombre: '', centropenal: '', departamento: '' }, () => {
             // Después de limpiar el estado, aplica un filtro que muestre todo
             applyIsotopeFilter({ nombre: '', centropenal: '', departamento: '' });
        });
    }    

    render() {
        const { items, nombre, centropenal, departamento } = this.state;
        // 1. Acceder a la ruta inyectada por el HOC
        const currentPath = this.props.location.pathname;

        // 2. Definir las rutas que deben ocultar el div
        const hiddenRoutes = ['/', '/registro', '/pago'];

        // 3. Lógica para determinar si el Navbar debe ocultarse
        const shouldHideNavbar = hiddenRoutes.includes(currentPath);

        return (
            
            <>
                <div className="section-full mobile-page-padding p-b80 bg-white bg-no-repeat bg-bottom-left" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container">
                        <div className="row">

                        </div>
                        {/* TITLE START */}
                        {/*                         <div className="section-head">
                            <div className="sx-separator-outer separator-left">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                    <h3 className="sep-line-one">About us</h3>
                                </div>
                            </div>
                        </div> */}
                        {/* TITLE END */}
                        <div className="section-content">
                            {shouldHideNavbar && (

                                <form onSubmit={this.handleSearch}>
                                    <div class="form-row">
                                        <div class="col-md-auto"> FILTROS</div>
                                        <div class="col-md-3 mb-3">
                                             {/* <label for="inputPassword" class="col-sm-2 col-form-label">FILTROS</label> */}
                                             <label></label>
                                            <input type="text" name="nombre" value={nombre} class="form-control quicksearch" id="quicksearch" placeholder="BUSCAR POR NOMBRE" onChange={this.handleChange}  />
                                        </div>
                                        <div class="col-md-3 mb-3">
                                            <UniqueSelect 
                                                data={devitems} 
                                                propertyKey="centropenal" 
                                                onValueChange = {this.handleChange}
                                            />                                             
{/*                                             <label for="inputEmail4">Centro penal</label>
                                            <select name="orderby" className="orderby select-box-border-style1 form-control" aria-label="Shop order">
                                                <option value="menu_order" selected="selected">CENTRO PENAL</option>
                                                <option value="popularity">Sort by popularity</option>
                                                <option value="rating">Sort by average rating</option>
                                                <option value="date">Sort by latest</option>
                                                <option value="price">Sort by price: low to high</option>
                                                <option value="price-desc">Sort by price: high to low</option>
                                            </select> */}
                                        </div>
                                        <div class="col-md-3 mb-3">
{/*                                             <label for="inputEmail4">Departamento</label>
                                            <select name="orderby" className="orderby select-box-border-style1 form-control" aria-label="Shop order">
                                                <option value="menu_order" selected="selected">Departamento</option>
                                                <option value="popularity">Sort by popularity</option>
                                                <option value="rating">Sort by average rating</option>
                                                <option value="date">Sort by latest</option>
                                                <option value="price">Sort by price: low to high</option>
                                                <option value="price-desc">Sort by price: high to low</option>
                                            </select> */}
                                            <UniqueSelect 
                                                data={devitems} 
                                                propertyKey="departamento" 
                                                onValueChange = {this.handleChange}
                                            />                                            
                                        </div>
                                        <div class="col-md-auto">
                                            <label></label>
                                            <button type="submit" className="site-button"><i className="fa fa-search arrow-animation" /></button>                                        
                                        </div>                                        
{/*                                         <div class="form-group col-md-6">
                                            <label for="inputCity">City</label>
                                            <input type="text" class="form-control" id="inputCity" />
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="inputState">State</label>
                                            <select id="inputState" class="form-control">
                                                <option selected>Choose...</option>
                                                <option>...</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label for="inputZip">Zip</label>
                                            <input type="text" class="form-control" id="inputZip" />
                                        </div> */}
                                    </div>
                                </form>
                            )}                            
                            <div className="row">
                                {/*                                 <div className="col-lg-5 col-md-12 col-sm-12">
                                    <div className="about-home-left">
                                        <h3 className="m-t0 sx-tilte">We are competitive in architecture solutions</h3>
                                        <p>Landscape design is a process of developing practical and pleasing outdoor living space. there are six principles of design that have been used by artists for centuries throughout all art forms, painting and floral design.</p>
                                        <div className="text-left">
                                            <NavLink to="/about-1" className="site-button-secondry btn-half"><span>Read More</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12">
                                    <div className="about-home-right">
                                        <OwlCarousel className="owl-carousel about-home number-slider owl-btn-vertical-center" {...options}>
                                            {images.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="sx-img-effect zoom-slow">
                                                    <NavLink to={"/about-1"}><img src={item} alt="" /></NavLink>
                                                    </div>
                                                </div>

                                            ))}

                                        </OwlCarousel>
                                        <div className="about-home-before">
                                            <img src={require('./../../images/about-slider/1-ab.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

//export default Filtros;
export default withLocation(Filtros);